// @flow
export type FBLoginResponse = {
  status: 'connected';
  authResponse: {
    accessToken: string;
    expiresIn: number;
    signedRequest: string;
    userID: string;
  };
};

const permissions = ['email', 'public_profile'];

export function FBLogin(window?: any): Promise<FBLoginResponse> {
  if (!window) return Promise.reject(new Error('window is not defined'));

  if (!window.fbInitialized) {
    window.fbAsyncInit();
  }

  return new Promise((resolve, reject) => {
    if (!(window: any).FB) return reject(new Error('FB is not defined'));
    (window: any).FB.login(response => resolve(response), { scope: permissions.join(', ') });
  });

}



// WEBPACK FOOTER //
// ./src/utils/facebook/index.js